// extracted by mini-css-extract-plugin
export var button = "_dh-4";
export var hasDarkBackground = "_dh-7";
export var hasLightBackground = "_dh-6";
export var iconWrapper = "_dh-0";
export var large = "_dh-2";
export var medium = "_dh-1";
export var small = "_dh-5";
export var xsmall = "_dh-3";